import ErrorPage from '../pages/error.vue';
import PrivacypolicyPage from '../pages/PrivacypolicyPage.vue';
import TermsPage from '../pages/TermsPage.vue';
import OtherHome from '../pages/other_home.vue';

var routes = [
  {
    path: '/',
    component: OtherHome,
  },
  {
    name: 'privacypolicy',
    path: '/privacypolicy/',
    component: PrivacypolicyPage,
  },
  {
    name: 'error',
    path: '/error/',
    component: ErrorPage,
  },
  {
    name: 'terms',
    path: '/terms/',
    component: TermsPage,
  },
];

export default routes;
